import useQueryState from './useQueryState';

export default useQueryState;
